// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1bo6g","title":"AfterFrontImage_title__3D_GD"};